import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 18\" id=\"arrow\">\r\n<g>\r\n\t<g id=\"arrow_expand-collapse\">\r\n\t\t<path id=\"arrow_Path_236\" class=\"st0\" d=\"M9,16.6c4.4,0,8-3.6,8-8s-3.6-8-8-8s-8,3.6-8,8S4.6,16.6,9,16.6z M4.4,6.4\r\n\t\t\tc0.3-0.3,0.8-0.3,1.1,0L9,9.9l3.5-3.5c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1c0,0,0,0,0,0l-4.1,4.1c-0.3,0.3-0.8,0.3-1.1,0\r\n\t\t\tL4.4,7.5C4.1,7.2,4.1,6.7,4.4,6.4C4.4,6.4,4.4,6.4,4.4,6.4z\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/icons/arrow.svg
// module id = NquZ
// module chunks = 0